import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexMega',
  setup(__props) {

const VariationRadio = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/VariationRadio.vue"))
const VariationCheckbox = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/VariationCheckbox.vue"))
const DefultStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/DefultStyle.vue"))
const BorderStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/BorderStyle.vue"))
const DashedStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/DashedStyle.vue"))
const OfferBorder = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/OfferBorder.vue"))
const InlineStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/InlineStyle.vue"))
const VerticalStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/VerticalStyle.vue"))
const HorizontalStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/HorizontalStyle.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(VariationRadio)),
      _createVNode(_unref(VariationCheckbox)),
      _createVNode(_unref(DefultStyle)),
      _createVNode(_unref(BorderStyle)),
      _createVNode(_unref(DashedStyle)),
      _createVNode(_unref(OfferBorder)),
      _createVNode(_unref(InlineStyle)),
      _createVNode(_unref(VerticalStyle)),
      _createVNode(_unref(HorizontalStyle))
    ])
  ]))
}
}

})